export default __webpack_public_path__ + "static/media/fummiNcake.d7791eda.jpeg";